import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { LoginScreen } from '../screens/auth/LoginScreen';
import { RegisterScreen } from '../screens/auth/RegisterScreen';
import { PhoneAuthScreen } from '../screens/auth/PhoneAuthScreen';
import { PrivacyPolicyScreen } from '../screens/legal/PrivacyPolicyScreen';
import { TermsOfServiceScreen } from '../screens/legal/TermsOfServiceScreen';
import type { AuthStackParamList } from './types';
import { pastelNavigationTheme } from './theme';

const Stack = createNativeStackNavigator<AuthStackParamList>();

const headerOptions = {
  headerStyle: { backgroundColor: '#fff1f2' },
  headerTintColor: '#1f2937',
  headerShadowVisible: false,
  headerTitleStyle: { fontWeight: '600' as const },
};

export function AuthNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: true, title: 'Annedaş', ...headerOptions }}>
      <Stack.Screen
        name="Login"
        component={LoginScreen}
        options={{
          title: 'Giriş',
          contentStyle: { backgroundColor: pastelNavigationTheme.colors.background },
        }}
      />
      <Stack.Screen
        name="Register"
        component={RegisterScreen}
        options={{
          title: 'Kayıt',
          contentStyle: { backgroundColor: pastelNavigationTheme.colors.background },
        }}
      />
      <Stack.Screen
        name="PhoneAuth"
        component={PhoneAuthScreen}
        options={{
          title: 'Telefon ile giriş',
          contentStyle: { backgroundColor: pastelNavigationTheme.colors.background },
        }}
      />
      <Stack.Screen
        name="TermsOfService"
        component={TermsOfServiceScreen}
        options={{
          title: 'Kullanım Koşulları',
          contentStyle: { backgroundColor: pastelNavigationTheme.colors.background },
        }}
      />
      <Stack.Screen
        name="PrivacyPolicy"
        component={PrivacyPolicyScreen}
        options={{
          title: 'Gizlilik Politikası',
          contentStyle: { backgroundColor: pastelNavigationTheme.colors.background },
        }}
      />
    </Stack.Navigator>
  );
}
